/**
 * ✅ src/packages/index.js
 * รวมทุกแพ็กเกจอัตโนมัติ (เสถียร + กัน self-import + debug)
 * ใช้ได้ทั้ง dev / build production
 */

function safeImportAll(ctx) {
    const results = [];
    ctx
      .keys()
      // กัน require.context ดึงไฟล์นี้เองเข้ามา (self-import loop)
      .filter((k) => k !== "./index.js")
      .forEach((key) => {
        try {
          const mod = ctx(key);
          const data = mod && mod.default ? mod.default : null;
  
          if (!data) {
            if (process.env.NODE_ENV === "development") {
              console.warn("⚠️  Skipped (no default export):", key);
            }
            return;
          }
  
          // ตรวจ schema หลักแบบเบา ๆ
          const { id, company, productLine, card, detail } = data;
          const missing = [];
          if (!id) missing.push("id");
          if (!company) missing.push("company");
          if (!productLine) missing.push("productLine");
          if (!card) missing.push("card");
          if (!detail) missing.push("detail");
  
          if (missing.length) {
            console.error(
              `❌ Invalid package schema: ${key} (missing: ${missing.join(", ")})`
            );
            return;
          }
  
          results.push(data);
  
          if (process.env.NODE_ENV === "development") {
            console.log("🧩 Loaded package:", id);
          }
        } catch (err) {
          console.error("❌ Error loading", key, err);
        }
      });
    return results;
  }
  
  // 🔍 โหลดทุก index.js ภายใต้ src/packages/**
  const modules = safeImportAll(require.context("./", true, /index\.js$/));
  
  // 🚫 กรองเฉพาะ active (active !== false)
  let packages = modules.filter((m) => m && m.active !== false);
  
  // 🧼 กันซ้ำตาม id (ถ้าเผลอทำโฟลเดอร์ซ้ำ)
  if (packages.length) {
    const seen = new Set();
    packages = packages.filter((p) => {
      if (seen.has(p.id)) {
        console.error("❌ Duplicate package id detected, skipped:", p.id);
        return false;
      }
      seen.add(p.id);
      return true;
    });
  }
  
  // 📚 จัดลำดับให้เสถียร (บริษัท > ชื่อแพ็กเกจ > id)
  packages.sort((a, b) => {
    const ac = (a.company || "").localeCompare(b.company || "");
    if (ac !== 0) return ac;
    const an = (a.nameTH || "").localeCompare(b.nameTH || "");
    if (an !== 0) return an;
    return (a.id || "").localeCompare(b.id || "");
  });
  
  if (process.env.NODE_ENV === "development") {
    console.log("✅ รวมทั้งหมด", packages.length, "แพ็กเกจ");
  }
  
  export default packages;
  